module.exports = __webpack_public_path__ + "img/logoForPrintRecipe.4497bcf8.png";